import { asyncGetDetailQuestionsAnswered, asyncGetDetailTopQuestionsAnswered, asyncGetDetailAverageInView,
    asyncGetDetailUniqueEngagedUsers, getSitesCountriesOrEmbeds, asyncGetDetailTopStoryClicks,
    asyncGetStories, asyncGetDetailStoryClicks,
    getSites, getCountries, getEmbeds, asyncGetDetailRevenueMetrics  } from 'utils/api/detail';

//utils
import { batchActions } from 'redux-batched-actions';
import { parseQueryString, sendErrorMessage, displaySuccessMessage, displayErrorMessage } from '@insticator/insticator-ui'; // iui-utils
// import {GET_DETAIL_QUESTIONS_ANSWERED, GET_DETAIL_TOP_QUESTIONS_ANSWERED} from "../homeState/home_analytics_data";
export const UPDATE_DETAIL_DATE_RANGE = "UPDATE_DETAIL_DATE_RANGE";
export const UPDATE_DETAIL_DROP_DOWN = "UPDATE_DETAIL_DROP_DOWN";
export const GET_DETAIL_RON_SITES = "GET_DETAIL_RON_SITES";
export const GET_DETAIL_COUNTRIES = "GET_DETAIL_COUNTRIES";
export const GET_DETAIL_EMBEDS = "GET_DETAIL_EMBEDS";

export const GET_DETAIL_QUESTIONS_ANSWERED = "GET_DETAIL_QUESTIONS_ANSWERED";
export const GET_DETAIL_QUESTIONS_ANSWERED_FETCHING = "GET_DETAIL_QUESTIONS_ANSWERED_FETCHING";
export const GET_DETAIL_TOP_QUESTIONS_ANSWERED = "GET_DETAIL_TOP_QUESTIONS_ANSWERED";
export const GET_DETAIL_TOP_QUESTIONS_ANSWERED_FETCHING = "GET_DETAIL_TOP_QUESTIONS_ANSWERED_FETCHING";
export const GET_DETAIL_AVERAGE_IN_VIEW = "GET_DETAIL_AVERAGE_IN_VIEW";
export const GET_DETAIL_AVERAGE_IN_VIEW_FETCHING = "GET_DETAIL_AVERAGE_IN_VIEW_FETCHING";
export const GET_DETAIL_UNIQUE_ENGAGED_USERS = "GET_DETAIL_UNIQUE_ENGAGED_USERS";
export const GET_DETAIL_UNIQUE_ENGAGED_USERS_FETCHING = "GET_DETAIL_UNIQUE_ENGAGED_USERS_FETCHING";
export const GET_TOP_STORY_CLICKS = "GET_TOP_STORY_CLICKS";
export const GET_TOP_STORY_CLICKS_FETCHING = "GET_TOP_STORY_CLICKS_FETCHING";
export const GET_DETAIL_STORIES = "GET_DETAIL_STORIES";
export const GET_DETAIL_STORY_CLICKS = "GET_DETAIL_STORY_CLICKS";
export const GET_DETAIL_STORY_CLICKS_FETCHING = "GET_DETAIL_STORY_CLICKS_FETCHING";

export const GET_DETAIL_CPM = "GET_DETAIL_CPM";
export const GET_DETAIL_REVENUE = "GET_DETAIL_REVENUE";
export const GET_DETAIL_IMPRESSION = "GET_DETAIL_IMPRESSION";
export const DETAIL_REVENUE_FETCHING = "DETAIL_REVENUE_FETCHING";

export const CLEAR_DETAIL_STATE = "CLEAR_DETAIL_STATE";


export const updataDetailDropDown = (items, itemType) => ({type:UPDATE_DETAIL_DROP_DOWN, items, itemType});
export const updateDetailDateRange = (dateRange) => ({type: UPDATE_DETAIL_DATE_RANGE, dateRange});


//individual GET REQUESTS FOR DETAIL VIEW


export const getDetailRevenueMetrics = ( paramString, dataType ) => dispatch => {
            dispatch(detailRevenueMetricsLoading(true));
    return asyncGetDetailRevenueMetrics(paramString)
        .then(response =>{
            return dispatch(batchActions([
                detailRevenueMetricsLoading(false),
                revenueMetrics(response.data, paramString, dataType),
            ]))
        }, err => dispatch(detailRevenueMetricsFail()))
};

const revenueMetrics = (data, paramString, dataType) => ({
    type: actionType(dataType),
    data,
    topRank: !!parseQueryString(paramString).topRank,
    viewType: parseQueryString(paramString).viewType
});

const detailRevenueMetricsLoading = (bool) => ({
    type: DETAIL_REVENUE_FETCHING,
    bool
});

const detailRevenueMetricsFail = () => batchActions([
    detailRevenueMetricsLoading(false),
    displayErrorMessage('There was an issue fetching your Revenue Metrics')
]);

//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//
export const getDetailQuestionsAnswered = ( paramString ) => dispatch => {
    dispatch(fetchingDetailQuestionsAnswered(true));
    return asyncGetDetailQuestionsAnswered(paramString)
        .then(response => {
            return dispatch(batchActions([
                fetchingDetailQuestionsAnswered(false),
                questionsAnswered(response.data, paramString)
                ]))
        }, err => dispatch(detailQuestionsAnsweredFailed()))
};

const questionsAnswered = (data, paramString) => ({
    type: GET_DETAIL_QUESTIONS_ANSWERED,
    data,
    topRank: !!parseQueryString(paramString).topRank,
    viewType: parseQueryString(paramString).viewType
});

const fetchingDetailQuestionsAnswered = (bool) => ({
    type: GET_DETAIL_QUESTIONS_ANSWERED_FETCHING,
    bool
});

const detailQuestionsAnsweredFailed = () => batchActions([
    fetchingDetailQuestionsAnswered(false),
    displayErrorMessage('There was an issue fetching your data for Questions Answered')
]);

//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//

export const getDetailTopQuestionsAnswered = (paramString) => dispatch => {
    dispatch(fetchingDetailTopQuestionsAnswered(true));
    return asyncGetDetailTopQuestionsAnswered(paramString)
        .then(response => {
            return dispatch(batchActions([
                fetchingDetailTopQuestionsAnswered(false),
                topQuestionsAnswered(response.data)])
            )
        }, err => dispatch(topQuestionsAnsweredFailed()))
};

const fetchingDetailTopQuestionsAnswered = (bool) => ({
    type: GET_DETAIL_TOP_QUESTIONS_ANSWERED_FETCHING,
    bool
});

const topQuestionsAnswered = (data) => ({
    type: GET_DETAIL_TOP_QUESTIONS_ANSWERED,
    data
});

const topQuestionsAnsweredFailed = () => batchActions([
    fetchingDetailTopQuestionsAnswered(false),
    displayErrorMessage('There was an issue fetching your data for Top Questions Answered')
]);


//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//

export const getDetailAverageInView = ( paramString ) => dispatch => {
    dispatch(fetchingDetailAverageInView(true));
    return asyncGetDetailAverageInView(paramString)
        .then(response => {
            return dispatch(batchActions([
                fetchingDetailAverageInView(false),
                averageInView(response.data, paramString)
            ]))
        }, err => dispatch(averageInViewFailed()))
};

const averageInView = (data, paramString) => ({
    type: GET_DETAIL_AVERAGE_IN_VIEW,
    data,
    topRank: !!parseQueryString(paramString).topRank,
    viewType: parseQueryString(paramString).viewType
});

const averageInViewFailed = () => batchActions([
    fetchingDetailAverageInView(false),
    displayErrorMessage('There was an issue fetching your data for Average In View')
]);

const fetchingDetailAverageInView = (bool) => ({ type: GET_DETAIL_AVERAGE_IN_VIEW_FETCHING, bool });

//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//

export const getDetailUniqueEngagedUsers = ( paramString ) => dispatch => {
    dispatch(fetchingDetailUniqueEngagedUsers(true));
    return asyncGetDetailUniqueEngagedUsers(paramString)
        .then(response => {
            return dispatch(batchActions([
                fetchingDetailUniqueEngagedUsers(false),
                uniqueEngagedUsers(response.data, paramString)
                ]))
        }, err => dispatch(uniqueEngagedUsersFailed()))
};

//-=-=-==-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=-=//
export const topStoryClicks = (data) => ({
    type: GET_TOP_STORY_CLICKS,
    data
});

export const getTopStoryClicks = ( paramString ) => dispatch => {
    dispatch(topStoryClicksFetching(true));
    asyncGetDetailTopStoryClicks(paramString)
        .then(response => {
            dispatch(batchActions([
                topStoryClicks(response.data),
                topStoryClicksFetching(false)
            ]))
        })
        .catch(err => {
            dispatch(topStoryClicksFetching(false))
        })
};

export const topStoryClicksFetching = (status) => ({
    type: GET_TOP_STORY_CLICKS_FETCHING,
    status
});

export const storyClicks = (data, paramString) => ({
    type: GET_DETAIL_STORY_CLICKS,
    topRank: !!parseQueryString(paramString).topRank,
    viewType: parseQueryString(paramString).viewType,
    data
});

export const getDetailStoryClicks = ( paramString ) => dispatch => {
    dispatch(getDetailStoryClicksFetching(true));
    asyncGetDetailStoryClicks(paramString)
        .then(response => {
            dispatch(batchActions([storyClicks(response.data, paramString),
                getDetailStoryClicksFetching(false)]))
        })
        .catch(err => dispatch(batchActions([
            sendErrorMessage('There was an issue fetching your data'),
            getDetailStoryClicksFetching(false)])
        ))
};

export const getDetailStoryClicksFetching = (status) => ({
    type: GET_DETAIL_STORY_CLICKS_FETCHING,
    status
});
// -=-=-=--=-=-=-=--=-==-=- get data for dropdown =-=-=-=-=-=-=-=-=-=---==-//

export const stories = (stories) => ({
    type: GET_DETAIL_STORIES,
    stories
});

export const getStories = (accountUUID) => dispatch => {
    asyncGetStories(accountUUID)
        .then(response => {
           return dispatch(stories(response.data))
        })
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your stories.')))
};

const uniqueEngagedUsers = (data, paramString) => ({
    type: GET_DETAIL_UNIQUE_ENGAGED_USERS,
    data,
    topRank: !!parseQueryString(paramString).topRank,
    viewType: parseQueryString(paramString).viewType
});

const uniqueEngagedUsersFailed = () => batchActions([
    fetchingDetailUniqueEngagedUsers(false),
    displayErrorMessage('There was an issue fetching your data for Unique Engaged Users')
]);

const fetchingDetailUniqueEngagedUsers = (bool) => ({ type: GET_DETAIL_UNIQUE_ENGAGED_USERS_FETCHING, bool });


// -=-=-=--=-=-=-=--=-==-=- get data for dropdown =-=-=-=-=-=-=-=-=-=---==-//

export const fetchRONSites = (accountUUID, paramString) => dispatch => {
    dispatch(updataDetailDropDown([], 'SITE'));
    return getSites(accountUUID, paramString)
        .then(response => dispatch(getDetailSites(response)))
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your sites')))
};
const getDetailSites = response => ({
    type: GET_DETAIL_RON_SITES,
    data: response.data
});

export const fetchCountries = (accountUUID, paramString) => dispatch => {
    return getCountries(accountUUID, paramString)
        .then(response => dispatch(getDetailCountries(response)))
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your countries')))
};
const getDetailCountries = response => ({
    type: GET_DETAIL_COUNTRIES,
    data: response.data
});

export const fetchEmbeds = (accountUUID) => dispatch => {
    return getEmbeds(accountUUID)
        .then(response => dispatch(getDetailEmbeds(response)))
        .catch(err => dispatch(displayErrorMessage('There was an issue fetching your embeds')))
};
const getDetailEmbeds = response => ({
   type: GET_DETAIL_EMBEDS,
   data: response.data
});

// -=-=-=-=-=-=-=- CLEAR DETAIL STATUS -=-=-=-=-= //

export const clearDetailState = () => ({type: CLEAR_DETAIL_STATE});


//helper

const actionType = (type) => {
  switch (type) {
      case 'AD_UNIT':
          return GET_DETAIL_RON_SITES;
      case 'GEO':
          return GET_DETAIL_COUNTRIES;
      case 'EMBED':
          return GET_DETAIL_EMBEDS;
      case 'CPM':
          return GET_DETAIL_CPM;
      case 'REVENUE':
          return GET_DETAIL_REVENUE;
      case 'IMPRESSION':
          return GET_DETAIL_IMPRESSION;
      default: break;
  }
};
